import { render, staticRenderFns } from "./MoleculeTheHeaderSubMenuDropDownAcademies.vue?vue&type=template&id=24129060&"
import script from "./MoleculeTheHeaderSubMenuDropDownAcademies.vue?vue&type=script&lang=js&"
export * from "./MoleculeTheHeaderSubMenuDropDownAcademies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports